import React, { useEffect, useRef } from 'react';

// GPTスロット要素ID
const slotElementId = 'div-gpt-ad-1768883112321-0';

/**
 * デスクトップ用広告バナー
 * 広告では、タブレット（768以下）はモバイルと同様に扱う
 */
const DesktopAd = ({
  isSearchResultOpen,
  isSearchModalOpen,
  isCategorySearchModalOpen,
  isShowNavi
}) => {
  // 広告が表示されたかどうかのフラグ（googletag.displayの多重実行を防ぐ）
  const displayedRef = useRef(false);

  // デスクトップでも、覆いかぶさるようなパネルが開いている間は広告を非表示に切り替える
  // 検索結果パネル、検索モーダル、カテゴリ検索モーダル、ルート検索モーダル
  const isHidden =
    (isSearchResultOpen || isSearchModalOpen || isCategorySearchModalOpen || isShowNavi);

  useEffect(() => {
    // 表示できない状態では、広告リクエストを発生させない
    if (isHidden) {
      return;
    }
    // 一度displayしたら、同一コンポーネント生存中は繰り返さない
    if (displayedRef.current) {
      return;
    }

    try {
      window.googletag = window.googletag || { cmd: [] };
      window.googletag.cmd.push(function () {
        window.googletag.display(slotElementId);
        // display実行済みフラグを立てる
        displayedRef.current = true;
      });
    } catch (e) {
    }
  }, [isHidden]);

  // 表示/非表示はclassNameで切り替える（DOMは維持する）
  const panelClassName = `desktop-ad-panel${isHidden ? ' is-hidden' : ''}`;

  return (
    <div className={panelClassName}>
      {/* GPT広告タグ（DOMは残し、表示だけ切り替える） */}
      <div id={slotElementId}></div>
    </div>
  );
};

export default DesktopAd;